import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";
import { PageHeader } from "../components/ui-bits";
import { Save } from "lucide-react";

const FIELDS = [
  ["email_task_assigned", "Task assignments"],
  ["email_task_reminders", "Task reminders (5/3/1 days before due date & evening)"],
  ["email_task_overdue", "Overdue task warnings"],
  ["email_chat_mentions", "Chat mentions"],
  ["email_brand_summary", "Brand activity summary"],
  ["email_daily_digest", "Daily digest of tasks and chats"],
  ["email_stock_alerts", "Materiali mancanti per nuovi ordini Shopify"],
];

const TZ_OPTIONS = ["UTC","Europe/London","Europe/Paris","Europe/Rome","Europe/Berlin","Europe/Madrid","America/New_York","America/Los_Angeles","Asia/Tokyo","Asia/Shanghai","Australia/Sydney"];

export default function NotificationSettingsPage() {
  const [prefs, setPrefs] = useState(null);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get("/notifications/preferences").then(r => setPrefs(r.data)).catch(()=>{});
  }, []);

  const save = async () => {
    if (!prefs) return;
    setSaving(true); setErr(""); setMsg("");
    try {
      await api.put("/notifications/preferences", prefs);
      setMsg("Preferences saved.");
    } catch (e) { setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
    finally { setSaving(false); }
  };

  if (!prefs) return <div className="text-[#737373] text-xs">Loading…</div>;

  return (
    <div data-testid="notif-settings">
      <PageHeader eyebrow="Preferences" title="Notification Preferences" description="Choose which emails you want to receive. In-app notifications always stay on."/>
      <div className="max-w-2xl card-dark p-6 space-y-4">
        {FIELDS.map(([key, label]) => (
          <label key={key} className="flex items-start gap-3 cursor-pointer">
            <input type="checkbox" checked={!!prefs[key]} onChange={(e)=>setPrefs({...prefs, [key]: e.target.checked})} className="mt-1" data-testid={`prefs-${key}`}/>
            <div>
              <div className="text-[#0A0A0A] text-sm">{label}</div>
            </div>
          </label>
        ))}
        <div className="border-t border-[#E5E5E5] pt-4">
          <label className="label-caps block mb-2">Preferred timezone</label>
          <select className="input-dark" value={prefs.timezone || "UTC"} onChange={(e)=>setPrefs({...prefs, timezone: e.target.value})} data-testid="prefs-timezone">
            {TZ_OPTIONS.map(tz => <option key={tz}>{tz}</option>)}
          </select>
        </div>

        {msg && <div className="text-emerald-400 text-xs">{msg}</div>}
        {err && <div className="text-red-600 text-xs">{err}</div>}

        <button onClick={save} disabled={saving} className="btn-gold inline-flex items-center gap-2" data-testid="prefs-save">
          <Save size={14}/> {saving ? "Saving…" : "Save preferences"}
        </button>
      </div>
    </div>
  );
}
